import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Button, FormModel, Input, Icon } from "@h3/antd-vue";
import OAuthApi from "@/apis/oauth";
import getDownloadUrlNew from '@cloudpivot/common/src/utils/getDownloadUrlNew';
import common from '@cloudpivot/common';
let MySetting = class MySetting extends Vue {
    constructor() {
        super(...arguments);
        this.current = "info";
        this.list = [
            {
                title: "个人信息",
                label: "info",
            },
            {
                title: "密码设置",
                label: "password",
            },
        ];
        this.userInfoList = [];
        this.ruleForm = {
            oldPwd: "",
            newPwd: "",
            surePwd: "",
        };
        this.rules = {};
        this.hasDiff = false;
    }
    get apiHost() {
        return window.config.apiHost;
    }
    get token() {
        return window.localStorage.getItem('token');
    }
    getUserInfo(val) {
        if (!val)
            return;
        this.current = "info";
        if (!this.userInfo.isShowUpdatePwdBtn) {
            this.list = this.list.filter((item) => item.label !== "password");
        }
        this.userInfoList = [
            {
                title: "",
                value: this.userInfo.imgUrl || this.userInfo.imgUrlId,
                type: "image",
            },
            {
                title: this.$t("languages.common.userInfo.name"),
                value: this.userInfo.name,
            },
            {
                title: this.$t("languages.common.userInfo.id"),
                value: this.userInfo.userId,
            },
            {
                title: this.$t("languages.common.userInfo.departmentName"),
                value: this.userInfo.departmentName,
            },
            // {
            //   title: this.$t("languages.common.userInfo.position"),
            //   value: this.userInfo.position,
            // },
            {
                title: this.$t("languages.common.userInfo.employeeNo"),
                value: this.userInfo.employeeNo,
            },
            // {
            //   title: this.$t("languages.common.userInfo.roleName"),
            //   value: this.userInfo.roleName,
            // },
            {
                title: this.$t("languages.common.userInfo.email"),
                value: this.userInfo.email,
            },
        ];
    }
    getDownloadUrlNew(refId) {
        return getDownloadUrlNew.getImageUrl(refId);
    }
    beforeMount() {
        this.setRules();
    }
    oldPwd(rule, value, callback) {
        if (value === "") {
            callback(new Error(`${this.$t('languages.common.passwordErrorTips1')}`));
        }
        else if (/[\u4e00-\u9fa5\s]/.test(value)) {
            callback("密码中不能包含汉字和空格");
        }
        else {
            callback();
        }
    }
    newPwd(rule, value, callback) {
        if (value === "") {
            callback(new Error(`${this.$t('languages.common.passwordErrorTips2')}`));
        }
        else if (/[\u4e00-\u9fa5\s]/.test(value)) {
            callback("密码中不能包含汉字和空格");
        }
        else if (value.length < 6 || value.length > 14 || !(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[^\u4e00-\u9fa5\s]{6,14}$/.test(value))) {
            callback(new Error(`${this.$t('languages.common.passwordErrorTips3')}`));
        }
        else if (value === this.ruleForm.oldPwd) {
            callback(new Error(`${this.$t('languages.common.passwordErrorTips4')}`));
        }
        else {
            callback();
        }
    }
    newPwdChange() {
        if (this.ruleForm.surePwd && this.ruleForm.newPwd !== this.ruleForm.surePwd) {
            this.hasDiff = true;
        }
        else {
            this.hasDiff = false;
        }
    }
    surePwd(rule, value, callback) {
        if (value === "") {
            callback(new Error(`${this.$t('languages.common.passwordErrorTips5')}`));
        }
        else {
            callback();
        }
    }
    surePwdChange() {
        if (this.ruleForm.surePwd && this.ruleForm.newPwd !== this.ruleForm.surePwd) {
            this.hasDiff = true;
        }
        else {
            this.hasDiff = false;
        }
    }
    /**
     * 自定义验证规则
     */
    setRules() {
        this.rules = {
            oldPwd: [{ validator: this.oldPwd, trigger: "change" }],
            newPwd: [{ validator: this.newPwd, trigger: "change" }],
            surePwd: [{ validator: this.surePwd, trigger: "change" }],
        };
    }
    /**
     * 修改密码
     */
    submitForm() {
        const ruleForm = this.$refs["ruleForm"];
        ruleForm.validate((valid) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (valid) { // rsa加密
                const result = yield OAuthApi.getRsaKey();
                const flag = typeof result === 'object' && result.hasOwnProperty('index') && result.hasOwnProperty('key');
                if (!flag) {
                    return;
                }
                const { index, key } = result;
                const oldPassword = common.utils.RsaEncrypt(this.ruleForm.oldPwd, key);
                const newPassword = common.utils.RsaEncrypt(this.ruleForm.newPwd, key);
                // rsa加密结束
                const params = {
                    index,
                    oldPassword,
                    newPassword,
                };
                const res = yield OAuthApi.changePassword(params);
                if (res.errcode) {
                    this.$message.error(res.errmsg);
                    return;
                }
                this.$message.success(`${this.$t("languages.common.changePwdSuccess")}`);
                this.$emit('success');
            }
        }));
    }
    /**
     * 重置表单
     */
    resetForm() {
        const ruleForm = this.$refs["ruleForm"];
        ruleForm.resetFields();
    }
    close() {
        this.resetForm();
        this.$emit("closepop");
    }
};
tslib_1.__decorate([
    Prop({ default: false })
], MySetting.prototype, "isShow", void 0);
tslib_1.__decorate([
    Prop({ default: {} })
], MySetting.prototype, "userInfo", void 0);
tslib_1.__decorate([
    Watch("isShow")
], MySetting.prototype, "getUserInfo", null);
MySetting = tslib_1.__decorate([
    Component({
        name: "my-setting",
        components: {
            AButton: Button,
            AFormModel: FormModel,
            AFormModelItem: FormModel.Item,
            AInput: Input,
            AIcon: Icon,
        },
    })
], MySetting);
export default MySetting;
